var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"course-teach"},[_c('div',{staticClass:"echarts-warpper"},[_c('e-charts',{ref:"echarts",attrs:{"options":_vm.options}}),_c('div',{staticClass:"echarts-name"},[_vm._v(_vm._s(_vm.name))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }